// Reset or what?

document.addEventListener(
    'click',
    function(event) {
        const target = event.target;

        if (target.classList.contains('.icon-remove-filter')) {
            target.parentElement.querySelector('input').value = '';
            document.querySelector('form.#basecrud-filter').submit();
        }
    },
    false
);
